import BasicLayout from '../layout/Basic';
import Head from 'next/head';
import { useTranslation } from 'next-i18next';
import { BasicContainer } from '../src/containers/BasicContainer/BasicContainer';
import staticData from '../public/StaticData/frontpage_data.json';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { TileSection } from '../src/components/FrontPageTiles/FrontPageTiles.style';
import { Tiles } from '../src/components/Tiles/Tiles';
import { useRouter } from 'next/router';
import { useRemoveLocalStorage } from '../src/hooks/useLocalStorage';

export default function Codex({ staticData }) {
  useRemoveLocalStorage('search');
  useRemoveLocalStorage('tags');
  useRemoveLocalStorage('filters');

  const { t } = useTranslation('common');
  const router = useRouter();
  const lang = router.locale;

  const handleLink = (link) => {
    router.push({
      pathname: `/book/${link.book_id}/folio/${link.folio_id}`,
    });
  };

  return (
    <BasicLayout>
      <Head>
        <title>{t('digital florentine codex') + ' | ' + t('codex')}</title>
        <meta
          property="og:title"
          content={t('digital florentine codex') + ' | ' + t('codex')}
          key="title"
        />
        <meta
          name="description"
          content={
            'Browse a collection of resources and essays...' +
            ' ' +
            'Explore una colección de recursos y ensayos...'
          }
          key="desc"
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content="https://dfc-fe.ch.digtest.co.uk/codex"
        />
        <meta
          property="og:image"
          content="https://dfc-fe.ch.digtest.co.uk/_next/static/media/TODO"
        />
      </Head>
      <BasicContainer title={t('Books of the Codex')}>
        <TileSection codex>
          {staticData.books.map((book, i) => {
            return (
              <Tiles
                key={i}
                type="tile"
                title={book.label[lang]}
                subTitle={book.sublabel[lang]}
                image={book.thumbnail}
                ariaLabel={t('go to') + ' ' + book.sublabel[lang]}
                alt={t('book thumbnail')}
                links={book.links[lang]}
                onClick={handleLink}
              />
            );
          })}
        </TileSection>
      </BasicContainer>
    </BasicLayout>
  );
}
export const getStaticProps = async ({ locale }) => {
  return {
    props: {
      staticData,
      ...(await serverSideTranslations(locale, ['common'])),
    },
  };
};
